import styled from "styled-components";
import { Input, ElementLight, ValidationState } from "../shared-style";

export const StyledInput = styled.input`
    ${Input}
    ${ElementLight}
    ${ValidationState}
`;
